import React from 'react'
import Navbar from "../Include/Navbar";
import Footer from "../Include/Footer";
function ContactUs() {
  return (
    <>
    <Navbar/>
    <div className="about-page">
      <div className="container">
        <h1>Contact Us</h1>
        <p className="intro">
          We'd love to hear from you. For any questions, support, feedback, or
          business inquiries, please contact us using the details below.
        </p>
        <section className="section">
          <h2>Merchant Legal Entity Name</h2>
          <p>
            <strong>Innosutra AI Private Limited</strong>
          </p>
        </section>
        <section className="section">
          <h2>Registered Address</h2>
          <p>
            E-213, 21 Floor, ANA Avant Garde, WEH, Shivaji Chowk, Mira Road,
            Thane - 401107
          </p>
        </section>
        <section className="section">
          <h2>Contact Information</h2>
          <ul>
            <li>
              <strong>Telephone No:</strong> 9727555057
            </li>
            <li>
              <strong>Email ID:</strong>{" "}
              innosutraaiprivatelimited@gmail.com
            </li>
          </ul>
        </section>
        <section className="section">
          <h2>Support</h2>
          <p>
            Our support team is available to assist you with any issues related
            to the platform, services, or general inquiries.
          </p>
        </section>
      </div>
    </div>
    <Footer/>
    </>
  )
}
export default ContactUs